import { useState, useRef, useContext } from 'react'
import { I18nContext } from '../../context/I18nProvider'
import Api from '../../api'
import ReactModal from 'react-modal'
import { useQuery } from 'react-query'
//Components
import ShortArrow from '../../components/svg/ShortArrow'
import PackCardLoader from '../../components/Home/PackCardLoader'
import ScrollSnap from '../../components/ScrollSnap'
//Intersection
import { useInView } from 'react-intersection-observer'
import PackCard from '../../components/Home/PackCard'

const PackagesDestacados = () => {
    const { language } = useContext(I18nContext)

    const { data: destacados, status } = useQuery(['destacadosHome', language], () =>
        Api.destacados.destacados(language)
    )
    // const { data: destacados, status } = useQuery(['destacadosHome'], () => getDestacadosHome())

    const [nextActive, setNextActive] = useState(false)
    const [prevActive, setPrevActive] = useState(false)

    //Estado para ocultar la flecha de ir a la derecha cuando se llego al final del scroll snap
    const [endOfSlider, setEndOfSlider] = useState(false)
    const [startOfSlider, setStartOfSlider] = useState(true)

    //TODO: Reever el tema de manejar el ancho de los PackCard dependiendo el ancho del padre
    //para que se muestren en vista, debe haber una forma de hacerlo desde css.
    //Ej: como lo maneja esta clase =>  .testimonials-cards-container de Testimonials.jsx
    const cardContainer = useRef()

    const [packages, inView] = useInView({
        triggerOnce: true,
        threshold: 0.25,
    })

    //Modal videos
    ReactModal.setAppElement('#root')

    //Estado para setear la url del video
    const [urlVideo, setUrlVideo] = useState('')
    //Estado para mostrar/ocultar el modal del video
    const [modalIsOpen, setIsOpen] = useState(false)

    //Click en el botón 'ver video' setea la url del video que se va a mostrar y abre el modal
    const handleClick = (url) => {
        setUrlVideo(url)
        setIsOpen(true)
    }

    const handleClose = () => {
        setIsOpen(false)
    }

    if (status === 'loading') {
        return <PackCardLoader />
    }

    if (status === 'error') {
        return null
    }

    if (destacados.length === 0) {
        return null
    }

    return (
        <section className={`incoming-home__packages animate slide-up ${inView ? 'in-view' : ''}`} ref={packages}>
            <div
                className={`pack-cards-container ${destacados.length <= 3 ? 'hide-arrow' : ''} ${
                    destacados.length === 1 ? 'one-card' : ''
                } ${destacados.length === 2 ? 'two-cards' : ''}`}
                ref={cardContainer}
            >
                <ScrollSnap
                    type="mandatory"
                    columnGap="16"
                    columnGapDt="16"
                    columnGapDtLarge="16"
                    // autoSlide={6000}
                    goNext={nextActive}
                    goPrev={prevActive}
                    setEndOfSlider={setEndOfSlider}
                    setStartOfSlider={setStartOfSlider}
                >
                    {destacados.map(({ title, subtitle, image, pdf, url, urlVideo }, index) => (
                        <PackCard
                            key={title}
                            title={title}
                            subtitle={subtitle}
                            image={image}
                            pdf={pdf}
                            url={url}
                            urlVideo={urlVideo}
                            handleClick={handleClick}
                            destacados={destacados}
                            cardContainer={cardContainer}
                        />
                    ))}
                </ScrollSnap>

                <ReactModal
                    isOpen={modalIsOpen}
                    parentSelector={() => document.querySelector('.incoming-home')}
                    ariaHideApp={true}
                    onRequestClose={handleClose}
                    shouldCloseOnEsc={true}
                    preventScroll={true}
                    className="modal-video"
                    overlayClassName="modal-overlay"
                >
                    <iframe src={urlVideo} width="100%" title="Video destacado"></iframe>
                </ReactModal>

                {!endOfSlider && (
                    <div
                        className="arrow-wrapper"
                        role="button"
                        aria-label="Bajar - Go down"
                        onMouseDown={() => setNextActive(true)}
                        onMouseUp={() => setNextActive(false)}
                    >
                        <ShortArrow />
                    </div>
                )}

                {!startOfSlider && (
                    <div
                        className="arrow-wrapper left-arrow"
                        role="button"
                        aria-label="Bajar - Go down"
                        onMouseDown={() => setPrevActive(true)}
                        onMouseUp={() => setPrevActive(false)}
                    >
                        <ShortArrow />
                    </div>
                )}
            </div>
        </section>
    )
}

export default PackagesDestacados
